<template>
  <div class="form-group">
    <label for="durationTravel" class="font-weight-bold"
      >Travel Duration
      <span class="text-danger" v-if="format === 'required'"> *</span>
      <div class="text-muted font-weight-normal" v-if="description">
        {{ description }}
      </div>
    </label>
    <div class="input-group">
      <input
        class="form-control"
        :class="{ 'is-invalid': errors && errors.first('durationTravel') }"
        :value="displayString"
        v-validate="{ decimal: true, min: 0, required: format === 'required' }"
        name="durationTravel"
        data-vv-as="Travel Duration"
        data-vv-validate-on="blur"
        type="text"
        inputmode="decimal"
        autocomplete="off"
        autocorrect="off"
        autocapitalize="off"
        spellcheck="false"
        @input="onInput"
      />
      <div class="input-group-append">
        <button type="button" class="btn btn-outline-secondary" @click="">
          {{ durationUnit }}
        </button>
      </div>
    </div>
    <label
      v-if="errors && errors.first('durationTravel')"
      class="text-danger"
      >{{ errors.first("durationTravel") }}</label
    >
  </div>
</template>

<script>
export default {
  name: "ObservationDurationTravel",
  inject: ["parentValidator"],
  props: {
    format: {
      type: String,
      validator: (value) => ["required", "optional"].includes(value),
    },
    description: {
      type: String,
      default: "",
    },
    value: {
      type: Number,
      default: null,
    },
  },
  created() {
    this.displayString = this.value !== null ? String(this.value) : "";
    // parent validator does not exist in observation edit
    if (this.parentValidator) {
      this.$validator = this.parentValidator;
    }
  },
  data() {
    return {
      durationUnit: "minutes",
      displayString: null,
      touched: false,
    };
  },
  computed: {},
  watch: {
    value(newValue) {
      // if the value changes externally, update the display value
      // Only if the new value has changed from the display value,
      // this prevents overwriting the display value while the user is typing.
      if (Number(this.displayString) === newValue) {
        return;
      }
      if (newValue === null || newValue === undefined) {
        this.displayString = "";
        return;
      }
      //
      console.log(
        "value changed new value",
        newValue,
        "display string",
        this.displayString,
      );
      //  detect value changes related to pressing backspace
      const backspaceValue = this.displayString.slice(
        0,
        this.displayString.length - 1,
      );
      if (Number(backspaceValue) === newValue) {
        this.displayString = backspaceValue ? backspaceValue : "";
        return;
      }
      const newString = String(newValue);
      this.displayString = newString;
    },
  },
  methods: {
    onInput(event) {
      // only emit if the new number is actually a number,
      // otherwise do not output so the person can continue to type.
      this.touched = true;

      // Keep digits and a single decimal point.
      const sanitized = event.target.value.replace(/[^0-9.]/g, "");
      const firstDotIndex = sanitized.indexOf(".");
      const newString =
        firstDotIndex === -1
          ? sanitized
          : sanitized.slice(0, firstDotIndex + 1) +
            sanitized.slice(firstDotIndex + 1).replace(/\./g, "");

      if (newString !== event.target.value) {
        console.log("filtered non-numeric characters, new string:", newString);
        const cursorStart = event.target.selectionStart;
        const cursorEnd = event.target.selectionEnd;
        // avoids unnecessary cursor adjustments)

        // avoid passing null to the value
        event.target.value = newString ? newString : "";
        // Restore cursor position (adjust for removed characters)
        event.target.setSelectionRange(
          cursorStart - (event.target.value.length - newString.length - 1),
          cursorEnd - 1,
        );
      }

      this.displayString = event.target.value;

      if (newString === "") {
        this.$emit("input", null);
        return;
      }
      const newNumber = Number(newString);
      if (isNaN(newNumber)) {
        return;
      }
      this.$emit("input", newNumber);
    },
    toggleDurationUnit() {
      this.durationUnit = this.durationUnit === "minutes" ? "hours" : "minutes";
    },
  },
};
</script>
